import { render, staticRenderFns } from "./ReceiptUploadStatus.vue?vue&type=template&id=ed9b5b7e&"
import script from "./ReceiptUploadStatus.vue?vue&type=script&lang=ts&"
export * from "./ReceiptUploadStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports